import { isContestVoteTerm } from '@diritto/common/content/contest';

export const PlayPickAndChooContentId = 2;

export enum ContestStage {
  Unknown = -1,
  None = 0,
  Writing = 1,
  Applied = 2,
  Approved = 3,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Vote = 3, // for vote
  Accepted = 4,
  Announced = 5,
}

export const ContestStageString = {
  [ContestStage.Unknown]: 'N/A',
  [ContestStage.None]: '시작전',
  [ContestStage.Writing]: '접수중',
  [ContestStage.Applied]: '검수중',
  [ContestStage.Approved]: '투표중',
  [ContestStage.Accepted]: '발표준비',
  [ContestStage.Announced]: '발표',
};

export const ContestContentStageString = {
  [ContestStage.Unknown]: 'N/A',
  [ContestStage.None]: '접수철회',
  [ContestStage.Writing]: '작성중',
  [ContestStage.Applied]: '접수완료',
  [ContestStage.Approved]: '검수통과',
  [ContestStage.Accepted]: '수상작',
  [ContestStage.Announced]: '수상작',
};

export enum ContentContestStatus {
  None = 'None',
  Writing = 'Writing',
  Applied = 'Applied',
  Withdrawal = 'Withdrawal',
}

export const ContentContestStatusString = {
  [ContentContestStatus.None]: '--',
  [ContentContestStatus.Writing]: '작성중',
  [ContentContestStatus.Applied]: '접수완료',
  [ContentContestStatus.Withdrawal]: '접수철회',
};

export enum ContestStep {
  ContentDetail = 'ContentDetail',
  Synopsis = 'Synopsis',
  Episodes = 'Episodes',
  Apply = 'Apply',
  Complete = 'Complete',
}

export type ContestStepInfoType = {
  isLoaded: boolean;
  step?: ContestStep;
  synopsisDone: boolean;
  episodesDone: boolean;
  episodesDoneCount: number;
  applyDone: boolean;
};

export enum ContentContestCheckStatus {
  NotYet = 'NotYet',
  Rejected = 'Rejected',
  Approved = 'Approved',
}

export enum RatingType {
  Diritto = 'Diritto',
  Ridi = 'Ridi',
}

export const ContentContestCheckStatusString = {
  [ContentContestCheckStatus.NotYet]: '검수대기',
  [ContentContestCheckStatus.Rejected]: '접수거절',
  [ContentContestCheckStatus.Approved]: '검수완료',
};

export enum ContentContestRatingStatus {
  NotYet = 'NotYet',
  Assessment = 'Assessment',
}

export const ContentContestRatingStatusString = {
  [ContentContestRatingStatus.NotYet]: '대기중',
  [ContentContestRatingStatus.Assessment]: '평가완료',
};

export type ContentContestInfoPayload = {
  checkStatus: ContentContestCheckStatus;
  rating: {
    dirittoStatus: ContentContestRatingStatus;
    dirittoRate?: number;
    dirittoStaffId?: number;
    ridiStatus: ContentContestRatingStatus;
    ridiRate?: number;
    ridiStaffId?: number;
  };
};

export function getContestStageString(stage: number) {
  if (stage >= ContestStage.Approved) {
    if (isContestVoteTerm()) {
      return '투표중';
    }
    return '심사중';
  }

  return '접수 완료';
}
